import type { PageStateProps } from "./PageState";

export const DEFAULT_FORBIDDEN_TITLE = "You don't have access to this";

/**
 * What a template's arrival live region should say for this state, instead of "{title} loaded":
 * an error or a no-permission state is not a successful load, so it announces its own heading.
 * Null for states where the page did load (empty, filtered) or is still loading.
 */
export function pageStateAnnouncement(state: PageStateProps | undefined): string | null {
  if (!state) return null;
  if (state.kind === "error") return state.title;
  if (state.kind === "forbidden") return state.title ?? DEFAULT_FORBIDDEN_TITLE;
  return null;
}
